module.exports = __webpack_public_path__ + "img/rope-facade-cladding.388d8b83.jpg";